const exportButton = document.getElementById('provider-export-js') as HTMLButtonElement
const exporterSiteSettingsId = exportButton.getAttribute('data-sitesetting-id')
const url = `/api/exporter/Provider?siteSettingId=${exporterSiteSettingsId}`
const fileName = "ProviderExport.csv";

const saveData = (function () {
    const a = document.createElement("a") as HTMLAnchorElement;
    document.body.appendChild(a);
    return function (url, fileName) {
        a.href = url;
        a.download = fileName;
        a.click();
    };
}());

exportButton.onclick = () => {
    saveData(url, fileName);
}
